define('pages/overview/overview_page_view',[
  'backbone',
  'jquery',
  '_',

  'modules/map/map_view',
  'modules/overview/overview_view',

  'text!./overview_page_template.html'

], function (Backbone, $, _, MapView, OverviewView, overview_page_template) {
  'use strict';
  var View = Backbone.View.extend({

    initialize: function (options) {

      this.subViews = [];

      this.render();

      this.players = new OverviewView({
        el: this.$('.js-overview-list')
      });
      this.subViews.push(this.players);

      this.listenTo(this.players.collection, 'sync', function () {

        this.map = new MapView({
          el: this.$('.js-overview-map'),
          players_collection: this.players.collection
        });
        this.subViews.push(this.map);

      }, this);

    },

    template: _.template(overview_page_template),
    subViews: [],

    events: {
      'click .js-switch-view': 'switchView'
    },

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    switchView: function (e) {
      var view;

      if (e) {
        e.preventDefault();
      }

      this.$('.js-switch-view').removeClass('active');
      $(e.currentTarget).addClass('active');
      view = $(e.currentTarget).attr('data-view');

      if (view === 'map') {
        this.$('.js-overview-list').addClass('hide-for-mobile');
        this.$('.js-overview-map').removeClass('hide-for-mobile');
      } else if (view === 'list') {
        this.$('.js-overview-map').addClass('hide-for-mobile');
        this.$('.js-overview-list').removeClass('hide-for-mobile');
      }

    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

